<template>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('driver.batchRegistrationProblemItems')"
    :visible.sync="batchDrawer"
    top="1vh"
    width="630px"
    @close="resetForm('ruleForm')"
  >
    <div style="overflow-y: auto; padding: 5px 10px">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        label-position="top"
        size="small"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <!--运单编号-->
            <div class="selectLabel">
              <el-select v-model="ruleForm.numberType">
                <el-option
                  v-if="activeName === '0'"
                  key="0"
                  :label="$t('collectionCenter.Barcode')"
                  :value="0"
                /><!--条形码-->
                <template v-else>
                  <el-option
                    key="1"
                    :label="$t('GlobalSetObj.waybillNumber')"
                    :value="0"
                  /><!--运单号-->
                  <el-option
                    key="2"
                    :label="$t('GlobalSetObj.ScanNumber')"
                    :value="1"
                  /><!--扫描单号-->
                </template>
              </el-select>
            </div>
            <el-form-item prop="inputValue">
              <el-input
                v-model="ruleForm.inputValue"
                :placeholder="$t('GlobalSetObj.CanBeEnteredMultiple2000')"
                :rows="2"
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--  问题件原因   -->
            <el-form-item :label="$t('GlobalSetObj.problemReason')" prop="problemId">
              <el-select
                v-model="ruleForm.problemId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
                @change="changeSelectProblemReason"
              >
                <el-option
                  v-for="(item, index) in causeProblemList"
                  :key="index"
                  :label="item.dictDescribe"
                  :value="item.problemId"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="isUploadingThree === false" :span="24">
            <!--  破损物品   -->
            <el-form-item :label="$t('scripting.damagedItems')" prop="damagedItemsType">
              <el-select
                v-model="ruleForm.damagedItemsType"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in damagedItemsTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!--  备注 -->
            <el-form-item :label="$t('GlobalSetObj.remark')" prop="problemReason">
              <el-input
                v-model="ruleForm.problemReason"
                :maxlength="200"
                :placeholder="$t('GlobalSetObj.pleaseInput')"
                :rows="2"
                show-word-limit
                type="textarea"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="isUploadingThree" :span="24">
            <el-form-item :label="$t('GlobalSetObj.UploadPictures')" prop="problemImg">
              <el-upload
                ref="uploadRef"
                v-model="ruleForm.problemImg"
                :before-upload="beforeAvatarUpload"
                :file-list="imageList"
                :http-request="(file) => upLoad(file, 1)"
                :limit="3"
                :on-change="handleChangeFile"
                :on-exceed="handleExceed"
                :on-remove="handleDeleteImgRemove"
                action="#"
                list-type="picture-card"
                multiple
              >
                <i class="el-icon-plus avatar-uploader-icon" />
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col v-else :span="24">
            <el-form-item prop="problemImg">
              <template slot="label">
                <div>
                  <span style="margin-right: 10px">{{ $t('GlobalSetObj.UploadPictures') }}</span>
                  <span style="font-size: 12px; font-weight: normal">{{
                    $t('GlobalSetObj.uploadImageWithRequirement')
                  }}</span>
                </div>
              </template>
              <div class="flex-start">
                <el-upload
                  :before-upload="beforeAvatarUpload"
                  :http-request="(file) => upLoad(file, 2)"
                  :on-change="handleChangeFile"
                  :on-remove="handleDeleteImgRemove"
                  :show-file-list="false"
                  action="#"
                  class="avatar-uploader"
                >
                  <!-- 上传后显示图片 + 删除按钮 -->
                  <div v-if="imageList1" class="preview-box">
                    <img :src="imageList1" class="avatar">
                    <!-- 红色删除按钮 -->
                    <i class="el-icon-close delete-icon" @click.stop="removeImg(1)" />
                  </div>
                  <div v-else class="upload-txt">
                    <i
                      class="el-icon-plus avatar-uploader-icon"
                      style="margin-top: 20px; font-size: 18px"
                    />
                    <div style="line-height: 20px">{{ $t('driver.packageLabel') }}</div>
                    <div style="font-size: 12px; line-height: 20px">
                      {{ $t('driver.waybillClearlyVisible') }}
                    </div>
                  </div>
                </el-upload>
                <el-upload
                  :before-upload="beforeAvatarUpload"
                  :http-request="(file) => upLoad(file, 3)"
                  :on-change="handleChangeFile"
                  :on-remove="handleDeleteImgRemove"
                  :show-file-list="false"
                  action="#"
                  class="avatar-uploader"
                >
                  <!-- 上传后显示图片 + 删除按钮 -->
                  <div v-if="imageList2" class="preview-box">
                    <img :src="imageList2" class="avatar">
                    <!-- 红色删除按钮 -->
                    <i class="el-icon-close delete-icon" @click.stop="removeImg(2)" />
                  </div>
                  <div v-else class="upload-txt">
                    <i
                      class="el-icon-plus avatar-uploader-icon"
                      style="margin-top: 20px; font-size: 18px"
                    />
                    <div style="line-height: 20px">{{ $t('driver.outerPackaging') }}</div>
                    <div style="font-size: 12px; line-height: 20px">
                      {{ $t('driver.showCompleteOuterPackaging') }}
                    </div>
                  </div>
                </el-upload>
                <el-upload
                  :before-upload="beforeAvatarUpload"
                  :http-request="(file) => upLoad(file, 4)"
                  :on-change="handleChangeFile"
                  :on-remove="handleDeleteImgRemove"
                  :show-file-list="false"
                  action="#"
                  class="avatar-uploader"
                >
                  <!-- 上传后显示图片 + 删除按钮 -->
                  <div v-if="imageList3" class="preview-box">
                    <img :src="imageList3" class="avatar">
                    <!-- 红色删除按钮 -->
                    <i class="el-icon-close delete-icon" @click.stop="removeImg(3)" />
                  </div>
                  <div v-else class="upload-txt">
                    <i
                      class="el-icon-plus avatar-uploader-icon"
                      style="margin-top: 20px; font-size: 18px"
                    />
                    <div style="line-height: 20px">{{ $t('driver.internalDamage') }}</div>
                    <div style="font-size: 12px; line-height: 20px">
                      {{ $t('driver.damageDetailCloseUp') }}
                    </div>
                  </div>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
          <el-col v-if="problemTotal > 0" :span="24">
            <div class="labelTitle">{{ $t('driver.latestExecutionProgress') }}</div>
            <div class="flx-between">
              <div>{{ $t('driver.executionTotal') }}: {{ problemTotal || 0 }}</div>
              <div>{{ $t('driver.remaining') }}: {{ remainingNumber || 0 }}</div>
              <div>{{ $t('driver.successCount') }}: {{ successNumber || 0 }}</div>
              <div>
                {{ $t('driver.failureCount') }}:
                <span style="color: red">{{ failureNumber || 0 }}</span>
              </div>
            </div>
          </el-col>
          <el-col v-if="failureNumber > 0" :span="24">
            <div class="labelTitle">{{ $t('driver.failedNumbers') }}</div>
            <div style="max-height: 230px; width: 100%; overflow: auto; font-size: 14px">
              <div v-for="(item, index) in failureDetails" :key="index">
                <span>{{ index + 1 }}. </span>
                <span>{{ item.orderNumber }}, </span>
                <span>{{ item.failureReason }}</span>
              </div>
            </div>
          </el-col>
          <el-col v-if="problemTotal > 0" :span="24" style="margin: 10px 0">
            <el-progress :color="customColorMethod" :percentage="percentage" />
          </el-col>
          <el-col v-if="remainingNumber === 0 && problemTotal > 0" :span="24">
            <div style="text-align: right">
              <!--              <el-button size="small" @click="resetForm('ruleForm')">{{ '导出' }}</el-button>-->
              <el-button size="small" @click="resetForm('ruleForm')">{{ $t('GlobalSetObj.Close') }}
              </el-button>
            </div>
          </el-col>
          <el-col v-else :span="24">
            <div style="text-align: right">
              <el-button
                v-if="statusBtn" size="small" type="warning"
                @click="stopTimer"
              >{{ showBtn ? $t('roleManage.cancel') : $t('GlobalSetObj.Canceled') }}
              </el-button>
              <el-button
                v-if="showBtn"
                :disabled="loadingBtn"
                :loading="loadingBtn1"
                size="small"
                type="primary"
                @click="submitForm('ruleForm')"
              >{{ loadingBtn1 ? $t('driver.executing') : $t('roleManage.confirm') }}
              </el-button>
              <el-button size="small" @click="resetForm('ruleForm')">{{ $t('GlobalSetObj.Close') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { uploadOos } from '@/utils/ali_oos_util';
import { newProblemRegistration } from '@/api/lanshou';

export default {
  props: {
    activeName: {
      type: String,
      default: () => '0'
    },
    causeProblemList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      imageList1: '',
      imageList2: '',
      imageList3: '',
      batchDrawer: false,
      ruleForm: {
        numberType: 0,
        inputValue: '',
        problemReason: '', //  备注
        problemId: '',
        problemImg: '',
        damagedItemsType: ''
      },
      exceptionTypeList: [],
      rules: {
        problemImg: [],
        problemReason: [
          {
            required: false,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ],
        problemId: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        damagedItemsType: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseChoose'),
            trigger: ['blur', 'change']
          }
        ],
        inputValue: [
          {
            required: true,
            message: this.$t('GlobalSetObj.pleaseInput'),
            trigger: ['blur', 'change']
          }
        ]
      },
      pictureList: [],
      imageList: [],
      showImg: true,
      editId: null,
      loadingBtn: false,
      causeProblemObj: {},
      resultObj: {
        failureDetails: [],
        failureNum: 0,
        operationTotal: 0,
        successesNum: 0
      },
      timer: 0,
      processedCount: 0,
      problemTotal: 0,
      percentage: 0,
      successNumber: 0,
      failureNumber: 0,
      remainingNumber: 0,
      failureDetails: [],
      inputValList: [],
      showBtn: true,
      loadingBtn1: false,
      statusBtn: false,
      isUploadingThree: true,
      uploadingCount: 0, // 跟踪正在上传的文件数量
      damagedItemsTypeList: [
        { value: 1, label: this.$t('scripting.glass') },
        { value: 2, label: this.$t('scripting.liquid') },
        { value: 3, label: this.$t('scripting.other') }
      ]
    };
  },
  mounted() {},
  methods: {
    changeSelectProblemReason(val) {
      console.log(val, 'changeSelectProblemReason');
      if (val) {
        this.causeProblemObj = this.causeProblemList.find((item) => item.problemId === val);
      }
      this.ruleForm.damagedItemsType = '';
      // 固定 这两个问题件的id 来判断必须上传 3 张图片
      if ([449, 459].includes(this.ruleForm.problemId)) {
        this.isUploadingThree = false;
      } else {
        this.isUploadingThree = true;
      }
      this.ruleForm.problemImg = '';
      this.imageList = [];
      this.pictureList = [];
      this.imageList1 = '';
      this.imageList2 = '';
      this.imageList3 = '';
    },
    // 加载弹框
    showDrawer(arg) {
      this.imageList = [];
      this.pictureList = [];
      this.editId = null;
      this.isUploadingThree = true;
      this.batchDrawer = true;
    },
    // 启动定时器
    startTimer() {
      this.loadingBtn1 = true;
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.fetchDataFn();
      }, 2000); // 每 2s 秒执行一次
    },
    stopTimer() {
      this.loadingBtn1 = false;
      this.showBtn = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
        this.loadingBtn1 = false;
        this.statusBtn = false;
        this.$emit('search');
        console.log('定时器已停止');
      }
    },
    // 循环调用接口的方法
    async fetchDataFn() {
      try {
        const data = {
          userId: this.$store.state.user.id,
          problemItemType: Number(this.activeName),
          problemReason: this.ruleForm.problemReason,
          problemId: this.ruleForm.problemId,
          problemTypeSub: this.causeProblemObj.problemTypeSub,
          problemType: this.causeProblemObj.dictValue,
          damagedItemsType: this.ruleForm.damagedItemsType,
          problemImg: '',
          photoList: []
        };
        if (this.isUploadingThree === false) {
          data.photoList.push(this.imageList1);
          data.photoList.push(this.imageList2);
          data.photoList.push(this.imageList3);
          data.problemImg = data.photoList.join(',');
        } else {
          if (this.pictureList.length > 0) {
            data.photoList = this.pictureList.map((item) => item.url);
            data.problemImg = data.photoList.join(',');
          }
        }
        if (this.inputValList.length === 0) {
          this.stopTimer();
          return;
        }
        let arr = [];
        // 通过 numberType 和 activeName 来确定要传的 运单号的参数 每次截取 10条参数
        if (this.ruleForm.numberType === 0 && this.activeName === '0') {
          data.scanNumbers = this.inputValList.splice(0, 10);
          arr = data.scanNumbers;
        } else {
          if (this.ruleForm.numberType === 1) {
            data.scanNumbers = this.inputValList.splice(0, 10);
            arr = data.scanNumbers;
          } else {
            data.waybillNumbers = this.inputValList.splice(0, 10);
            arr = data.waybillNumbers;
          }
        }
        if (data.scanNumbers && data.scanNumbers.length === 0) {
          this.stopTimer();
        }
        if (data.waybillNumbers && data.waybillNumbers.length === 0) {
          this.stopTimer();
        }
        const res = await newProblemRegistration(data);
        if (res.code === 200) {
          // 计算总数和进度 和百分比
          this.processedCount = this.processedCount + arr.length;
          this.percentage = Number(((this.processedCount / this.problemTotal) * 100).toFixed(2));
          if (res.data) {
            this.resultObj = res.data;
            this.successNumber = this.resultObj.successesNum + this.successNumber;
            this.failureNumber = this.resultObj.failureNum + this.failureNumber;
            this.remainingNumber = this.problemTotal - this.successNumber - this.failureNumber;
            if (res.data.failureDetails.length > 0) {
              res.data.failureDetails.forEach((item) => {
                this.failureDetails.push(item);
              });
            }
          }
        }
      } catch (error) {
        console.error('请求失败:', error);
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.inputValList = [];
          if (this.ruleForm.inputValue) {
            // 单号格式化，去除空格
            const orderNumber = this.ruleForm.inputValue.split(/[(\r\n)\r\n]+/);
            orderNumber.map((item) => {
              if (item) {
                this.inputValList.push(item.trim());
              }
            });
          }
          console.log(this.imageList1, 'this.imageList1');
          console.log(this.imageList2, 'this.imageList2');
          console.log(this.imageList3, 'this.imageList3');
          // 固定 这两个问题件的id 来判断必须上传 3 张图片
          if ([449, 459].includes(this.ruleForm.problemId)) {
            if (this.imageList1 === '' || this.imageList2 === '' || this.imageList3 === '') {
              console.log('submitForm');
              this.$message.error(this.$t('driver.selectUploadThreeImages'));
              return;
            }
          }
          console.log('submitForm');
          this.problemTotal = this.inputValList.length;
          this.remainingNumber = this.problemTotal;
          this.statusBtn = true;
          // 启动定时器 开始分断请求
          this.startTimer();
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.ruleForm = {
        numberType: 0,
        inputValue: '',
        problemReason: '', //  备注
        problemId: '',
        problemImg: '',
        damagedItemsType: ''
      };
      this.timer = 0;
      this.processedCount = 0;
      this.problemTotal = 0;
      this.percentage = 0;
      this.successNumber = 0;
      this.failureNumber = 0;
      this.remainingNumber = 0;
      this.failureDetails = [];
      this.inputValList = 0;
      this.showBtn = true;
      this.loadingBtn1 = false;
      this.$refs[formName].resetFields();
      this.imageList = [];
      this.pictureList = [];
      this.statusBtn = false;
      this.batchDrawer = false;
      this.imageList1 = '';
      this.imageList2 = '';
      this.imageList3 = '';
    },
    // 上传图片
    async upLoad(option, index) {
      console.log(option, 'list');
      console.log(index, 'index');
      const files = option.file;
      try {
        const res = await uploadOos(files, 'eventImages');
        if (res.code === 200) {
          this.ruleForm.problemImg = res.url;
          if (index === 2) {
            this.imageList1 = res.url;
          } else if (index === 3) {
            this.imageList2 = res.url;
          } else if (index === 4) {
            this.imageList3 = res.url;
          } else {
            if (this.pictureList.length < 3) {
              this.pictureList.push({
                url: res.url,
                uid: files.uid
              });
            }
          }
        } else {
          // 上传图片失败
          this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
        }
      } catch (e) {
        // 上传图片失败
        this.$message.error(this.$t('fixDutyFine.imageUploadFailed'));
      } finally {
        this.uploadingCount--;
        this.checkUploadComplete();
      }
    },
    // 检查是否所有上传都已完成
    checkUploadComplete() {
      if (this.uploadingCount === 0 && this.loadingBtn) {
        this.loadingBtn = false;
      }
    },
    // 图片上传前
    beforeAvatarUpload(rawFile) {
      // 获取文件扩展名
      const extension = rawFile.name.split('.').pop().toLowerCase();
      // 支持的图片格式
      const allowedExtensions = ['jpg', 'jpeg', 'png', 'gif'];
      // 检查文件格式是否为图片格式
      if (!allowedExtensions.includes(extension)) {
        this.$message.error(this.$t('fixDutyFine.formatFile'));
      } else {
        // 开始上传时增加计数并显示loading
        this.uploadingCount++;
        this.loadingBtn = true;
      }
      return allowedExtensions.includes(extension);
    },
    removeImg(val) {
      if (val === 1) {
        this.imageList1 = '';
      }
      if (val === 2) {
        this.imageList2 = '';
      }
      if (val === 3) {
        this.imageList3 = '';
      }
    },
    // 改变图片选择
    handleChangeFile(file, fileList) {
      console.log(file, fileList);
    },
    handleExceed(file, fileList) {
      if (fileList.length >= 3) {
        this.$message.error(this.$t('driver.maxThreeImages'));
      }
    },
    customColorMethod(percentage) {
      if (percentage < 30) {
        return '#909399';
      } else if (percentage < 70) {
        return '#e6a23c';
      } else {
        return '#67c23a';
      }
    },
    // 移除触发的钩子
    handleDeleteImgRemove(file, fileList) {
      console.log(file, fileList);
      if (file.uid) {
        const uid = file.uid;
        const findIndex = this.pictureList.findIndex((url) => url.uid === uid);
        console.log(findIndex, 'findIndex');
        this.pictureList.splice(findIndex, 1);
        console.log(this.pictureList, 'this.pictureList');
      }
      if (this.pictureList.length === 0) {
        this.ruleForm.problemImg = '';
      }
    }
  }
};
</script>

<style scoped>
>>> .el-upload--picture-card {
  width: 80px;
  height: 80px;
  line-height: 80px;
}

>>> .el-upload-list__item {
  width: 80px;
  height: 80px;
}

.selectLabel ::v-deep .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.selectLabel ::v-deep .el-input__icon {
  line-height: 28px !important;
}

.labelTitle {
  color: #00A551;
  cursor: pointer;
  font-weight: bold;
  //margin: 10px 0;
}

>>> .avatar-uploader {
  width: 105px !important;
  height: 100px !important;
  display: inline-block !important;
}

/* 上传框样式，完美匹配截图 */
>>> .avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px !important;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 105px !important;
  height: 130px !important;
  transition: all 0.3s;
}

/* 上传后隐藏+号，只显示图片 */
>>> .avatar-uploader .el-upload--picture-card {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 105px !important;
  height: 130px !important;
}

/* 图片样式 */
>>> .avatar-uploader .el-upload-list__item {
  width: 105px !important;
  border-radius: 6px;
}

/* 图片 */
>>> .avatar-uploader .avatar {
  width: 105px;
  display: block;
}

.upload-txt {
  width: 100%;
  height: 100%;
  padding: 5px;
  display: flex;
  flex-direction: column;
  align-items: center; /* 垂直居中 */
  text-align: center; /* 文字换行后依然居中 */
  word-break: break-all; /* 自动换行 */
  white-space: normal; /* 允许换行 */
  font-size: 14px;
  color: #666;
}

/* 图片容器 */
.preview-box {
  position: relative;
  width: 105px;
  height: 120px;
}

.avatar {
  width: 105px;
  height: 120px;
  object-fit: cover;
  border: 1px solid #eee;
}

/* 右上角红色删除按钮 */
.delete-icon {
  position: absolute;
  top: 1px;
  right: 1px;
  background: red;
  color: #fff;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  cursor: pointer;
  font-size: 12px;
  z-index: 99;
}
</style>
